import { type UseQueryResult, useQuery } from 'react-query';
import { SandboxOptionsService } from '../../services/wealthlane-identity-services';

const useGetSandboxTenant = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const sandboxTenant = useQuery(
    ['getSandboxTenant'],
    async () => {
      return await handleRequest(SandboxOptionsService.getApiIdentityApiSandboxOptionsTenants());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return sandboxTenant;
};

export default useGetSandboxTenant;
